import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

export const usePortfolioAnalyticsQueries = () => {
  const api = useApi();

  return {
    fah: (query?: ApiQueryParams<"getPortfolioAnalyticsFeelingAtHomeV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("feeling-at-home", query),
        queryFn: () => api.getPortfolioAnalyticsFeelingAtHomeV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
    communityPillars: (query?: ApiQueryParams<"getPortfolioAnalyticsCommunityPillarsV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("community-pillars", query),
        queryFn: () => api.getPortfolioAnalyticsCommunityPillarsV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
    communitySupport: (query?: ApiQueryParams<"getPortfolioAnalyticsCommunitySupportV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("community-support", query),
        queryFn: () => api.getPortfolioAnalyticsCommunitySupportV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
    platformResidents: (query?: ApiQueryParams<"getPortfolioAnalyticsPlatformResidentsV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("platform-residents", query),
        queryFn: () => api.getPortfolioAnalyticsPlatformResidentsV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
    platformTicketsRatings: (query?: ApiQueryParams<"getPortfolioAnalyticsTicketsRatingsV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("platform-tickets-satisfaction", query),
        queryFn: () => api.getPortfolioAnalyticsTicketsRatingsV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
    platformTicketsResolutionTime: (query?: ApiQueryParams<"getPortfolioAnalyticsTicketsResolutionTimeV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("platform-tickets-resolution-time", query),
        queryFn: () => api.getPortfolioAnalyticsTicketsResolutionTimeV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
    platformReach: (query?: ApiQueryParams<"getPortfolioAnalyticsPlatformReachV3">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PORTFOLIO_ANALYTICS("platform-reach", query),
        queryFn: () => api.getPortfolioAnalyticsPlatformReachV3(query),
        select: commonAPIDataSelector,
        staleTime: 10 * 60 * 1000, // 10 minutes
      }),
  };
};
